export function ms() {
    return performance.now();
}
//# sourceMappingURL=performance.js.map